/* System defined core library */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';


@Component({
  selector: 'generic-button',
  templateUrl: './generic-button.component.html'
})
export class GenericButtonComponent implements OnInit {

  /* Input-OutPut parameters decalartions */
  @Input() hasContent: string = '';
  @Input() buttonClass: string = '';
  @Input() btnId: string = '';
  @Input() isDisable: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  /* Constructor declaration with required injected services */
  constructor(private selectedExamDetailService: SelectedExamDetailService) {

  }

  ngOnInit(): void {

  }

  /*Emit Click Event */
  submit(event: any) {
    this.onClick.emit(event);
  }

  getAriaLabel() {
    const label = this.hasContent === '' ? 'Continue to next page' : this.hasContent;
    return label;
  }

  getClass() {
    let programCode = this.selectedExamDetailService.programCode ? this.selectedExamDetailService.programCode.toLowerCase() : '';
    let inputBtnClass = !!this.buttonClass ? this.buttonClass + ' ' : '';

    let successBtnClass = !programCode ? 'textSucBtn' : 'textSucBtn textSucBtn-' + programCode;
    let textWrapNormalClass = !programCode ? 'textWrapNormal' : 'textWrapNormal textWrapNormal-' + programCode;
    let tempSucBtnClass = !programCode ? 'tempSucBtn' : 'tempSucBtn tempSucBtn-' + programCode;

    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';

    if (clientCode) {
      successBtnClass = !clientCode ? 'textSucBtn' : 'textSucBtn textSucBtn-' + clientCode;
      textWrapNormalClass = !clientCode ? 'textWrapNormal' : 'textWrapNormal textWrapNormal-' + clientCode;
      tempSucBtnClass = !clientCode ? 'tempSucBtn' : 'tempSucBtn tempSucBtn-' + clientCode;
    }
      if (this.hasContent === 'Submit') return inputBtnClass + tempSucBtnClass;
    if (this.hasContent === '') return inputBtnClass + tempSucBtnClass;
    if (this.hasContent !== '' && this.hasContent !== 'Cancel Appointment') return inputBtnClass + successBtnClass + ' ' + textWrapNormalClass;
    if (this.hasContent !== '') return inputBtnClass + successBtnClass;
  }
}
